var _path, _g, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoutes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2954_4486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 26,
    width: 385,
    height: 448
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 26H442V473.349H57V26Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2954_4486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.6987 370.12V308.334C95.6987 283.144 105.988 260.309 122.569 243.754C124.273 242.049 126.053 240.395 127.895 238.829V129.582H102.479C95.235 129.582 89.3823 123.705 89.3823 116.498V39.5861C89.3823 32.3548 95.2601 26.5146 102.479 26.5146H179.516C186.76 26.5146 192.613 32.3799 192.613 39.5861V116.498C192.613 123.73 186.735 129.582 179.516 129.582H154.1V223.125C164.377 219.127 175.569 216.922 187.262 216.922H252.619V129.595H227.19C219.946 129.595 214.094 123.73 214.094 116.523V39.6112C214.094 32.3799 219.972 26.5272 227.19 26.5272H304.24C311.472 26.5272 317.337 32.4049 317.337 39.6112V116.523C317.337 123.755 311.459 129.595 304.24 129.595H278.812V216.922H311.986C329.97 216.922 346.3 209.59 358.143 197.772C369.986 185.954 377.33 169.624 377.33 151.69V129.595H351.914C344.67 129.595 338.793 123.73 338.793 116.523V39.6112C338.793 32.3799 344.67 26.5272 351.914 26.5272H428.952C436.196 26.5272 442.073 32.4049 442.073 39.6112V116.523C442.073 123.755 436.196 129.595 428.952 129.595H403.523V151.69C403.523 176.88 393.247 199.74 376.653 216.27C360.073 232.825 337.176 243.102 311.96 243.102H278.561C276.982 265.761 267.094 286.189 251.917 301.341C235.336 317.896 212.439 328.161 187.199 328.161C169.215 328.161 152.885 335.505 141.042 347.323C134.6 353.752 129.499 361.51 126.153 370.145H147.258C154.501 370.145 160.379 376.01 160.379 383.216V460.128C160.379 467.36 154.501 473.212 147.258 473.212H70.2075C62.9637 473.212 57.0859 467.335 57.0859 460.128V383.216C57.0859 375.985 62.9637 370.145 70.2075 370.145H95.6361L95.6987 370.12ZM252.318 243.102H187.262C172.949 243.102 159.677 247.752 148.887 255.585L148.624 255.798C145.954 257.765 143.435 259.908 141.104 262.252C129.261 274.07 121.917 290.4 121.917 308.334V329.439L122.569 328.787C139.149 312.232 162.059 301.968 187.262 301.968C205.258 301.968 221.588 294.636 233.444 282.818C243.859 272.403 250.814 258.53 252.318 243.077V243.102Z",
    fill: "#231942"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.502 376.5C111.502 376.5 98.1135 290.957 129 254.501C157.805 220.501 256.001 229.001 256.001 229.001C256.001 229.001 332.291 237.861 361.5 214C397 185 390.5 122.501 390.5 122.501",
    stroke: "#FFB35A",
    strokeWidth: 30,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 370,
    width: 48,
    height: 30,
    fill: "#231942"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 99,
    width: 48,
    height: 30,
    fill: "#231942"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutes);
export default __webpack_public_path__ + "static/media/routes.ddd45d5ac5c852b7028620ad0dc06a93.svg";
export { ForwardRef as ReactComponent };